// extracted by mini-css-extract-plugin
export default {"editableHeader":"EditableHeader_editableHeader__IML-+","header":"EditableHeader_header__onV4J"};